import _ from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FiArrowRightCircle } from 'react-icons/fi';
import CardH from 'src/components/cards/card-h';
import CardV from 'src/components/cards/card-v';
import Carousels from 'src/components/carousels';
import Image from 'src/components/image';
import { SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import styled from 'styled-components';
import useVideoIframe from './section-schneider/utils';

const SectionEnergyVer2 = ({ data }) => {
  if (_.isEmpty(data)) return null;
  const allData = {
    item1: convertDatasets(data.dataSet, 'image-left', true),
    item2: convertDatasets(data.dataSet, 'background', true),
    item3: convertDatasets(data.dataSet, 'image-right', true),
    item4: convertDatasets(data.dataSet, 'header-image', true),
    item5: convertDatasets(data.dataSet, 'title', true),
    item6: convertDatasets(data.dataSet, 'tag', true),
    item7: convertDatasets(data.dataSet, 'bg-icon', true),
    item8: convertDatasets(data.dataSet, 'bg-bottom', true),
    item9: convertDatasets(data.dataSet, 'background-mobile', true)

  };
  const [resDataTag, setResDataTag] = useState();
  const [resDataTagVideo, setResDataTagVideo] = useState();

  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        if (!_.isEmpty(allData)) {
          const res = await Promise.all([GET(`/api/search/advertorials/tag${convertObjPath({ name: allData.item6 })}&limit=1`, false, true), GET('/api/v1.0/video/section-two')]);
          if (!_.isEmpty(res[0])) setResDataTag(_.uniqBy(res[0].data, 'id'));
          if (!_.isEmpty(res[1].block1)) setResDataTagVideo(res[1].block1);
        }
      } catch (err) {
        console.error(`${timestamp()} ==========> EVENT_ELECTION-2566 ERROR :`, err?.message);
      }
    })();
  }, []);
  return (
    <SectionWrapper id='section-ptt-ver.2' background={allData.item2} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
      <div className='bg-header'></div>
      {!_.isEmpty(allData?.item7) && (
        <div className='bg-icon'>
          <Image image={allData.item7} external={true} title={'icon'} type='CARD_SMALL' />
        </div>
      )}
      {!_.isEmpty(allData?.item8) && (
        <div className='bg-bottom'>
          <Image image={allData.item8} external={true} title={'icon'} type='CARD_SMALL' />
        </div>
      )}
      <div className='container'>
        {!_.isEmpty(allData?.item4) && (
          <div className='header'>
            <Image image={allData.item4} external={true} title={'icon'} type='CARD_SMALL' />
            <span>{allData.item5}</span>
          </div>
        )}
        <div className='all-item'>
          <div className='image-left'>{!_.isEmpty(allData?.item1) && <Image image={allData.item1} external={true} title={'building'} type='CARD_SMALL' />}</div>
          <div className='content'>
            {!_.isEmpty(resDataTagVideo?.data) && (
              <div className='left-content'>
                <div className='carousels-video'>
                  <Carousels slideShow={1} showDots={true} responsiveShow={1}>
                    {_.map(resDataTagVideo.data.slice(0, 4), (el, i) => (
                      <div key={i} className={`item-video --${i + 1}`}>
                        {useVideoIframe(el)}
                      </div>
                    ))}
                  </Carousels>
                  {!_.isEmpty(resDataTagVideo.title) && (
                    <div className='title-video'>
                      <span>{resDataTagVideo.title}</span>
                    </div>
                  )}
                </div>
                {_.map(resDataTagVideo.data.slice(4, 5), (el, i) => (
                  <CardH
                    data={el}
                    external={true}
                    eyeBall={false}
                    showFooter={false}
                    isVideo={true}
                    showReadmore={true}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_POSITION,
                      router: router?.pathname,
                      section: 'section-energy-time',
                      position: 'ใต้: section-bitkub',
                      data: {
                        title: resDataTagVideo.data.slice(4, 5)[0]?.title,
                        heading: 'วีดีโอ-section-energy-time',
                        index: 1
                      }
                    }}
                  />
                ))}
              </div>
            )}
            {!_.isEmpty(resDataTag) && (
              <div className='right-content'>
                <a href={`/tags/${allData.item6}`} className='more'>
                  ดูทั้งหมด <FiArrowRightCircle />
                </a>
                {resDataTag.slice(0, 1).map(item => (
                  <div key={item.id}>
                    <CardV
                      data={item}
                      description={true}
                      path={item.link}
                      nonePadding={true}
                      isSmall={true}
                      cardV={false}
                      badge={true}
                      withTarget={true}
                      showFooter={false}
                      showReadmore={true}
                      //! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'section-energy-time',
                        position: 'ใต้: section-bitkub',
                        data: {
                          title: item?.title,
                          heading: 'ข่าว-section-energy-time',
                          index: 1
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='image-right'>{!_.isEmpty(allData?.item3) && <Image image={allData.item3} external={true} title={'building'} type='CARD_SMALL' />}</div>
        </div>
      </div>
      {!_.isEmpty(resDataTagVideo?.data) && !_.isEmpty(allData.item9) &&
      <div className='content-mobile'>
        <img src={allData.item9} className='background-mobile' />
        <div className='wrapper'>
          <div className='carousels-video'>
            <Carousels slideShow={1} showDots={true} responsiveShow={1}>
              {!_.isEmpty(resDataTagVideo?.data) && _.map(resDataTagVideo?.data.slice(0, 4), (el, i) => (
                <div key={i} className={`item-video --${i + 1}`}>
                  {useVideoIframe(el)}
                </div>
              ))}
            </Carousels>
            <div className='title-video'>
              <span>{allData.item6}</span>
            </div>
          </div>
          <div className='card-video-wrapper'>
            {!_.isEmpty(resDataTagVideo?.data.slice(4, 6)) && resDataTagVideo?.data.slice(4, 6).map((item, index) => (
                <CardV
                data={item}
                description={false}
                path={item.link}
                nonePadding={true}
                isSmall={true}
                cardV={false}
                badge={true}
                withTarget={true}
                showFooter={false}
                isVideo={true}
                external={true}
                showReadmore={true}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-ptt',
                  position: 'ใต้: section-schneider',
                  data: {
                    title: item?.title,
                    heading: 'ข่าว-section-ptt',
                    index: index + 1
                  }
                }}
              />
            ))}
          </div>
          <a href={`/tags/${allData.item6}`} className='more'>
            ดูทั้งหมด <FiArrowRightCircle />
          </a>
        </div>
      </div>}
    </SectionWrapper>
  );
};

const SectionWrapper = styled.div`
  background-image: url(${props => props.background});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  @media (max-width: 992px) {
    background-image: unset;
  }
  .content-mobile {
    display: none;
    @media (max-width: 992px) {
      display: block;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: auto;
      .background-mobile {
        width: 100%;
        display: none;
        @media (max-width: 992px) {
          display: block;
        }
      }
      .wrapper {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 44%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 10px 15px;
        width: 90%;
        background: linear-gradient(0deg, rgba(38, 57, 151, 1) 0%, rgba(248, 149, 34, 1) 100%);
        border-radius: 12px;
        .carousels-video {
          width: 100%;
          background: linear-gradient(90deg, rgba(38, 57, 151, 1) 0%, rgba(248, 149, 34, 1) 100%);
          padding: 0 0 10px 0;
          margin-bottom: 5px;
          border-radius: 12px;
          .carousel-wrapper {
            margin:  0 0 30px 0px;
          }
          .slick-list {
            border-radius: 12px;
          }
          .title-video {
              text-align: center;
              color: #fff;
              font-size: 18px;
              font-weight: 500;
            }
        }
        .card-video-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .card-wrapper {
            width: 48%;
            padding: 0 5px;
            .card-v-thumb  {
              margin-bottom: 10px;
            }
            .icon {
              color: #fefefe;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 40px;
            }
            .card-v-content-title {
              font-size: 16px;
              color: #fff;
              -webkit-line-clamp: 2;
        
            }
            .read-more {
              color: #F89522;
              font-size: 14px;
            }
          }
        }
        .more {
          align-self: flex-end;
          color: #fff;
        }
      }
    }
  }
  .bg-header {
    position: absolute;
    background: linear-gradient(90deg, rgba(38, 57, 151, 1) 0%, rgba(248, 149, 34, 1) 100%);
    height: 200px;
    width: 100%;
    clip-path: ellipse(58% 45% at 52% 0%);
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    @media (max-width: 992px) {
      display: none;
    }
  }
  .bg-icon {
    right: 5%;
    position: absolute;
    width: 110px;
    height: auto;
    @media (max-width: 992px) {
      display: none;
    }
    img {
      border-bottom-left-radius: 14px;
      border-bottom-right-radius: 14px;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
  }
  .bg-bottom {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
  .icon-good-news {
    position: absolute;
    width: 250px;
    height: auto;
    left: 0;
  }
  .icon-ptt {
    right: 0;
    position: absolute;
    width: 180px;
    height: auto;
  }
  .container {
    position: relative;
    min-height: 400px;
    @media (max-width: 992px) {
      display: none;
    }
    .header {
      padding-top: 24px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      span {
        padding-left: 8px;
        font-size: 26px;
        font-weight: 500;
        color: #fff;
      }
      .resolution-image {
        width: 18%;
      }
    }
    .building {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .all-item {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      /* margin-left: 40px; */
      min-height: 400px;
      .image-left {
        z-index: 1;
        width: 20%;
        height: auto;
      }
      .content {
        z-index: 1;
        width: 60%;
        margin: 40px 0px 30px 0px;
        padding: 0 10px;
        display: flex;
        gap: 10px;
        .left-content {
          width: 50%;
          background: linear-gradient(0deg, rgba(38, 57, 151, 1) 0%, rgba(248, 149, 34, 1) 100%);
          padding: 12px;
          border-radius: 12px;
          .carousels-video {
            background: linear-gradient(90deg, rgba(38, 57, 151, 1) 0%, rgba(248, 149, 34, 1) 100%);
            /* border-radius: 12px; */
            padding: 6px;
            .item-video {
              .resolution-dailymotion {
                padding-top: 60%;
              }
            }
            .carousel-wrapper {
              margin: 0;
              display: block;
              .slick-dots {
                bottom: 0 !important;
                top: 80%;
                button {
                  &:before {
                    font-size: 13px !important;
                    color: #a9a9a9 !important;
                    opacity: 1 !important;
                  }
                }
                .slick-active {
                  button {
                    &:before {
                      font-size: 15px !important;
                      color: #fff !important;
                      opacity: 1 !important;
                    }
                  }
                }
              }
            }
            .title-video {
              text-align: center;
              color: #fff;
              font-size: 18px;
              font-weight: 500;
            }
          }
          .card-h {
            padding-top: 14px;
            width: 100%;
            .card-h-thumb {
              width: 50%;
              height: auto;
              max-width: none;
              margin-right: 0;
              position: relative;
              .icon {
                color: #fefefe;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 40px;
              }
              img {
                max-width: none;
              }
            }
            .card-h-content {
              width: 45%;
              margin-left: 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              h3 {
                height: 40px;
                color: #fff;
              }
            }
          }
        }
        .right-content {
          position: relative;
          width: 50%;
          background: linear-gradient(0deg, rgba(38, 57, 151, 1) 0%, rgba(248, 149, 34, 1) 100%);
          padding: 12px 12px 0 12px;
          @media (max-width: 1200px) {
            padding: 12px 10px 0 10px;
          }
          .more {
            position: absolute;
            top: -30px;
            right: 0;
            color: #0600E7;
          }
          border-radius: 12px;
          .card-v {
            min-height: 0px;
            margin-bottom: 10px;
            .card-v-thumb {
              margin-bottom: 8px;
            }
            .card-v-content-title {
              font-size: 16px;
              color: #fff;
              -webkit-line-clamp: 1;
              @media (max-width: 1200px) {
                font-size: 14px;
              }
            }
            .text-excerpt-3 {
              margin-top: 6px;
              color: #fff;
              font-size: 14px;
              font-weight: 300;
            }
          }
          .read-more {
            text-align: end;
          }
        }
      }
      .read-more {
        font-weight: 500;
        margin-top: 10px;
        color: #00a5d7;
        font-size: 14px;
      }
      .image-right {
        width: 20%;
        height: auto;
        margin-right: 10px;
      }
    }
  }
`;

export default SectionEnergyVer2;
